import { useDispatch } from 'react-redux'
import { EmptyObject } from 'type-fest'

import { reset } from 'features/user'
import { SIGN_OUT } from 'features/user/api/mutations/signOut'
import { SignOutData } from 'features/user/api/types/signOut'
import { AppDispatch } from 'providers/redux'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { UseSignOut } from './types'

export const useSignOut = (): UseSignOut => {
  const dispatch: AppDispatch = useDispatch()

  const { isPending, mutateAsync } = useMutation<EmptyObject, SignOutData>({
    mutation: SIGN_OUT,
    onCompleted: async () => {
      dispatch(reset())
    },
  })

  const signOut = (): void => {
    void mutateAsync({})
  }

  return {
    loading: isPending,
    signOut,
  }
}
